import { api, removeSession, setSession } from './utils'
import { signInAction, signOutAction } from '../redux/userActions'
import { store } from '../redux/store'
import { User } from '../types/redux'

export interface ISignInRequestAnswer {
	success: boolean
	message: string

	session: string

	errorCode:
	'MFA' | 'NOT_EXISTS' |
	'BAD_2FA' | 'BAD_LOGIN_OR_PASS' |
	'ALREADY_AUTHORIZED'
}

interface IGetUserDataRequestAnswer {
	success: boolean
	message: 'NOT_AUTHORIZED' | ''
	userData: User
}

export async function signIn(nick: string, password: string, code: string): Promise<ISignInRequestAnswer> {
	const result = await (await fetch(
		`${api}/cabinet/signIn`,
		{
			method: 'POST',
			body: JSON.stringify({
				nick,
				password,
				code: code ? code.replace(new RegExp(' ', 'g'), '') : ''
			})
		}
	)).json() as ISignInRequestAnswer

	if (result.success) {
		setSession(result.session)
		await getUserData()
	} else if (!result.success && result.errorCode !== 'ALREADY_AUTHORIZED') {
		removeSession()
	}

	return result
}

export async function getUserData(): Promise<void> {
	const userData = await (await fetch(
		`${api}/cabinet/userData`,
	)).json() as IGetUserDataRequestAnswer

	if (userData.success) {
		signInAction(userData.userData)
	} else {
		removeSession()
	}
}

export async function signOut(): Promise<void> {
	await fetch(`${api}/cabinet/signOut`)
	removeSession()

	signOutAction()
}

export function isAuthenticated(): boolean {
	return store.getState().user.nick !== ''
}
